<template>
  <!-- MEMO: 項目が一個しかなく、その項目が満たされたら親で表示を切り替えるので、コンポーネント内ではバリデーションチェックはしない -->
  <ValidationContainer>
    <template #header-content>
      <svg style="height:34px;width:34px;;fill:#fff;">
        <use xlink:href="/images/trial/trial-star.svg#trial-star" />
      </svg>
      <span>
        プロフィールを完成させて<br>
        5日間お試しプランを今すぐGET！
      </span>
    </template>

    <template #description>
      <svg style="height:20px;width:20px;;fill:#FF4EB2;">
        <use xlink:href="/images/trial/trial-star.svg#trial-star" />
      </svg>
      <span>
        以下の項目が未記入もしくは未選択です
      </span>
    </template>

    <template #validation-list>
      <li>プロフィール画像</li>

    </template>
  </ValidationContainer>
</template>

<script>
import ValidationContainer from '../../ValidationContainer';

export default {
  name: 'MyDetailValidationContainer',
  components: {
    ValidationContainer
  },
}
</script>
